import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import {
  Close as CloseIcon,
  Description as DescriptionIcon,
  TableChart as TableChartIcon,
  TextSnippet as TextIcon,
} from "@mui/icons-material";
import { FILE_UPLOADED } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import SkeletonFileItem from "../Loaders/SkeletonFileItem";

const DocumentFilesList = ({
  files = [],
  fileNamesMapping = {},
  onRemoveFile,
  disabled = false,
  pendingFilesCount = 0
}) => {
  const { t } = useTranslationApp();
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    if (extension === 'pdf') return <DescriptionIcon />;
    if (extension === 'csv') return <TableChartIcon />;
    return <TextIcon />;
  };

  if (files.length === 0 && pendingFilesCount === 0) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
      {files.map((fileUrl, index) => {
        const originalName = fileNamesMapping[fileUrl];
        const fileName = originalName || fileUrl.split('/').pop() || `archivo-${index + 1}`;

        return (
          <Box
            key={index}
            sx={{
              border: "1px solid #e5e5e5",
              borderRadius: 2,
              p: 2,
              backgroundColor: "card.background",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
                backgroundColor: "#f5f5f5",
                borderRadius: 1
              }}>
                {getFileIcon(fileName)}
              </Box>

              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" color="text.primary" noWrap>
                  {fileName.split('.')[0]}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {fileName.split('.').pop()?.toUpperCase() || 'FILE'}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "success.main",
                  border: "1px solid",
                  borderColor: "success.main",
                  borderRadius: "16px",
                  px: 2,
                  py: 0.5,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    textAlign: "center",
                    lineHeight: "normal",
                  }}
                >
                  {t(FILE_UPLOADED)}
                </Typography>
              </Box>
            </Box>

            <IconButton
              onClick={() => onRemoveFile(index)}
              disabled={disabled}
              size="small"
              color="error"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        );
      })}

      {Array.from({ length: pendingFilesCount }).map((_, index) => (
        <SkeletonFileItem key={`skeleton-${index}`} />
      ))}
    </Box>
  );
};

export default DocumentFilesList;
